import Head from 'next/head'

function MetaData(): JSX.Element {
  return (
    <Head>
      <title>
        Atur Ulang Kata Sandi / Reset Password | Ralali.com
      </title>
      <meta
        name="description"
        content="Atur ulang kata sandi. Masukkan email yang terdaftar. Kami akan mengirimkan kode verifikasi untuk atur ulang kata sandi Anda."
      />
      <meta
        name="keywords"
        content="atur ulang kata sandi, reset password"
      />
    </Head>
  )
}

export default MetaData
